import { Wheel } from "spin-wheel";
import { getCookie, setCookie, hashAndEncodeBase64, getContrast } from "./utils";
  
const apiBase = process.env.API_URL;
const apiToken = process.env.PUBLIC_ENTRY_TOKEN; 
const cookieExpiration = '365';
const makeURL = "https://hook.us1.make.com/qy3uuf82o87jispj2c418q15fb1qxk9p"
const congratulationsDelayMS = 2000;
const entryDelayMS = 2000;

const clackSound = new Howl({
  src: ["./clack.mp3"],
  preload: true,
});


// Cached results from the api
let accounts;
let spinners;

// State
let selectedSpinner;
let spinsSinceClaim = 0;
let prize;
let slots = [];
let spinnerRotations = 0;
let slotsPassed = 0;
let spinnerInstance;

// Runs on the page load, remove all code out of the html
async function pageLoad() {
  // Get spinner info from API
  await getSpinner();

  // Instantiate the spinner
  attachSpinner(".spinner-container");

  // Draw the spinner and slots
  await initSpinner(selectedSpinner.Id);

  // Update some UI
  document.getElementById("companyName").innerHTML = selectedSpinner["System: Account Name"];

  // Reset the Spinner on winner dialog close
  const winnerDialog = document.querySelector("#winner");

  document.getElementById("entryForm").addEventListener("submit", async function(event) {
    event.preventDefault();

    if (!this.checkValidity()) {
      alert('Please fill out the form correctly.');
    } else {
      $("#spin-loading").show();
      await postEntry();
      $("#spin-loading").hide();
    }
  });

  setTimeout(() => {
    entryFormModal.showModal();
  }, entryDelayMS);


  // // TODO REMOVE THIS - THIS IS FOR TESTING
  //         // Update the UI
  //         document.getElementById('winnerName').innerHTML = "Nick";
  //         document.getElementById('prize').innerHTML = "1 Free Month"; //`You have won <b>1 Month Free</b>`;
  //         congratulationsModal.showModal();
  //         const jsConfetti = new JSConfetti();
  //         jsConfetti.addConfetti()

}




function attachSpinner(selector) {
  const container = document.querySelector(selector);
  spinnerInstance = new Wheel(container, null);
}


async function reset() { 
  spinnerRotations = 0;
  slotsPassed = 0;
  await initSpinner(selectedSpinner.Id);
}


// Sets the selected spinner and draws on the screen
async function initSpinner(selectedSpinnerId) {
  // Get Spinner data
  selectedSpinner = await spinners.find(obj => obj.Id === selectedSpinnerId);
  const backgroundColors = [selectedSpinner["Slot Colour 1"] || '#EF373C', selectedSpinner["Slot Colour 2"] || '#2B2A5B', selectedSpinner["Slot Colour 3"] || '#fff'];
  const itemLabelColors = backgroundColors.map((item) => getContrast(item));

  // Get slots
  const electrifyFilter = `[Spinner]="${selectedSpinnerId}"`;
  const response = await $.ajax({
    url: `${apiBase}/Spinner%20Slot/select.json?filter=${electrifyFilter}`,
    method: "GET",
    dataType: "json",
    beforeSend: function(xhr) {
      xhr.setRequestHeader('Authorization', `Bearer ${apiToken}`);
    },
  });

  slots = response.map((item) => ({
    ...item,
    label: item["Label"],
  }));

  const props = {
    items: slots,
    isInteractive: false,
    borderColor: "#000",
    itemBackgroundColors: backgroundColors,
    borderWidth: 15,
    itemLabelColors: itemLabelColors,
    itemLavelRadiusMax: 0.2,
    lineColor: "#000",
    lineWidth: 2,
    rotationSpeedMax: 600,
    rotationResistance: -60,
    overlayImage: "./Spinner.svg", //pointer/border
    onCurrentIndexChange: (event) => {
      clackSound.play();
      slotsPassed += 1;
      if (slotsPassed == slots.length) { 
        spinnerRotations += 1;
        slotsPassed = 0;
      }
    },
    onRest: (event) => {
      const currentSlot = event.currentIndex;
      prize = props.items[event.currentIndex];

      if (spinnerRotations == 0) {
        spinWarningModal.show();
      } else { 
        const jsConfetti = new JSConfetti();
        jsConfetti.addConfetti();

        // Small Delay!
        setTimeout(()=> {
          congratulationsModal.showModal();
        }, congratulationsDelayMS);
      }
    },
    // image: './img/example-0-image.svg', // center image
  };

  // const logo = getAccountLogo(selectedSpinnerId);
  $('.accountLogo').attr("src", selectedSpinner["System: Logo URL"]);
  $("#accountName").text(selectedSpinner["System: Account Name"]);

  spinnerInstance.init(props);
}

async function getSpinner() {
  const urlParams = new URLSearchParams(window.location.search);
  const spinnerParam = urlParams.get("spinner");

  const electrifyFilter = `[Id]="${spinnerParam}"`;

  spinners = await $.ajax({
    url: `${apiBase}/Spinner/json_spinners/select.json?filter=${electrifyFilter}`,
    dataType: "json",
    beforeSend: function(xhr) {
      xhr.setRequestHeader('Authorization', `Bearer ${apiToken}`);
    },
  });

  [selectedSpinner] = spinners;
}

/**
 * Creates a lead object from input values.
 *
 * @param {Object} leadData - An object with lead information.
 * @param {string} leadData.firstName - The first name of the lead.
 * @param {string} leadData.lastName - The last name of the lead.
 * @param {string} leadData.email - The email address of the lead.
 * @param {string} leadData.phone - The phone number of the lead.
 * @returns {Object} - A lead object with the provided information.
 */

  
async function postEntry() {
  // const cookieName = `${selectedSpinner.Account}_${selectedSpinner.Id}_${$("#email").val()}`;
  const cookieName = selectedSpinner.Id;
  // const cookieValue = $("#email").val();

  const data = [{
    "First Name": $("#firstName").val(),
    "Last Name": $("#lastName").val(),
    "Email": $("#email").val(),
    "Phone": $("#phone").val(),
    "Account": selectedSpinner.Account,
    "Spinner": selectedSpinner.Id
  }];

  try {
    const [response] = await $.ajax({
      url: `${apiBase}/Spinner%20Entry/create.json`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(data),
      beforeSend: function(xhr) {
        xhr.setRequestHeader('Authorization', `Bearer ${apiToken}`);
      },
    });

    if (response.status === 200 || response.status === 201) {
      // setCookie(cookieName, data[0].Email, cookieExpiration);
      try {
        const entryDetail = await $.ajax({
          url: makeURL,
          dataType: "json",
          method: "POST",
          data: response
        });

        entryFormModal.close();
        const winningIndex = slots.findIndex(item => item.Offer === entryDetail[0]["Offer Won"]);
        const duration = 5000;
        spinnerInstance.spinToItem(winningIndex, duration, false, 8, 1);

        // Update the UI
        document.getElementById('winnerName').innerHTML = data[0]["First Name"];
        document.getElementById('prize').innerHTML = slots[winningIndex].label;

      } catch (e) { 
        console.error(e);
      }
    } else {
      // Handle Re-entry attempts and other errors.
      const electrifyError = response.errors[0].error;
      const electrifyErrorMessage = response.errors[0].message;

      if (electrifyError === 409) {
        entryFormModal.close();
        // setCookie(cookieName, data[0].Email, cookieExpiration);
        $('#existingEntryText').text(`The email address ${data[0].Email} has already been used to enter this promotion.`);
        existingEntry.showModal();
      } else { 
        console.error(response);
      }
    }
  } catch (e) { 
      console.error("Error: " + e);
  }
}


export {
  attachSpinner,
  initSpinner,
  getSpinner,
  postEntry,
  reset,
  pageLoad,
};
